import { OGMAIViewTab } from '~/Slices/schema';
import * as ManageMetaProducts from './ManageMetaProducts';

export const route = {
	addByProductNumber: (blueprintId, metaProductId?) => {
		let addByProductNumberLink;

		if (metaProductId) {
			let linkPrefix = '';

			if (ManageMetaProducts.onExceptionWorkflow()) {
				linkPrefix = '/exceptions';
			}

			addByProductNumberLink = `${linkPrefix}/masterorderguides/${blueprintId}/masteritems/${metaProductId}/addbyproductnumber`;
		} else {
			addByProductNumberLink = `/masterorderguides/${blueprintId}/masteritems/new/addbyproductnumber`;
		}

		return addByProductNumberLink;
	},
	admin: {
		users: () => {
			return '/admin/users';
		},
		editUser: (userId: number) => {
			return `/admin/users/${userId}`;
		},
		newUser: () => {
			return '/admin/users/new';
		},
	},
	customers: () => {
		return '/customers';
	},
	editCustomer: (customerId: number) => {
		return `/customers/${customerId}/edit`;
	},
	logout: () => {
		return '/logout';
	},
	SSOExpiredSession: () => '/singleSignOn/expired',
	masterItemListing: (blueprintId: string) => {
		return `/masterorderguides/${blueprintId}/masteritems`;
	},
	masterItem: (blueprintId: string, metaproductId: string) => {
		return `/masterorderguides/${blueprintId}/masteritems/${metaproductId}/prioritize`;
	},
	prioritize: (blueprintId, metaProductId?, dynamic?) => {
		let prioritizeLink;

		if (metaProductId) {
			let linkPrefix = '';

			if (ManageMetaProducts.onExceptionWorkflow()) {
				linkPrefix = '/exceptions';
			}

			prioritizeLink = `${linkPrefix}/masterorderguides/${blueprintId}/masteritems/${metaProductId}/prioritize`;
			if (dynamic) {
				prioritizeLink += '?dynamic=true';
			}
		} else {
			prioritizeLink = dynamic
				? `/masterorderguides/${blueprintId}/masteritems/new/prioritize?dynamic=true`
				: `/masterorderguides/${blueprintId}/masteritems/new/prioritize`;
		}

		return prioritizeLink;
	},
	rearrange: (blueprintId, groupingId?) => {
		let route = `/masterorderguides/${blueprintId}/masteritems/rearrange`;
		if (groupingId) {
			route += `?gid=${groupingId}`;
		}
		return route;
	},
	reports: () => {
		return '/reports';
	},
	sequenceCharts: () => {
		return '/invoiceSequences';
	},
	restrictions: {
		manageRestrictions: () => {
			return '/restrictions';
		},
		addByProductNumber: () => {
			return '/restrictions/addbyproductnumber';
		},
	},
	customerNotes: {
		customerNotes: () => {
			return '/notes';
		},
	},
	syscoSelfService: {
		addCustomer: () => {
			return '/selfservice/addnewcustomer';
		},
		manageCustomers: () => {
			return '/selfservice/managecustomers';
		},
		manageLocations: (customerId: number) => {
			return `/selfservice/managecustomers/${customerId}/locations`;
		},
		addLocation: (customerId: number) => {
			return `/selfservice/managecustomers/${customerId}/locations/add`;
		},
		massImportLocations: (customerId: number) => {
			return `/selfservice/managecustomers/${customerId}/locations/massimport`;
		},
	},
	customCategories: {
		manageCustomCategories: () => {
			return '/customcategories';
		},
		createCustomCategory: () => {
			return '/customcategories/create';
		},
		editCustomCategory: (categoryId: number) => {
			return `/customcategories/${categoryId}`;
		},
	},
	opsAdmin: () => {
		return '/opsadmin';
	},
	optimizationDetail: (metaProductId) => {
		return `/ogmai/${OGMAIViewTab.suggestedOptimization}/details/${metaProductId}`;
	},
};

export default route;
